(function() {
'use strict'

AppTabs.createTab( {
	name: 'report',
	icon: 'file-alt',
	text: 'Report',
	create: function(init) {
		const tab = this;
		const anchor = document.getElementById('download-report-anchor');
		const span = document.getElementById('report-filename');
		let reportObject = null;
		let objectURL = null;
		function reset() {
			anchor.download = '';
			anchor.href = '';
			span.innerText = '';
			if (reportObject != null) {
				tab.container.removeChild(reportObject);
				reportObject = null;
			}

			if (objectURL != null) {
				URL.revokeObjectURL(objectURL);
				objectURL = null;
			}
		}

		init.setController( {
			OpenReport(data, reportsTab = null) {
				reset();
				const request = new XMLHttpRequest();
				request.open('POST', ajax_object.ajax_url, true);
				request.responseType = 'blob';
				request.onload = function() {
					if ( data.emailTo || data.reportType == 'dnr-disk' || data.reportType == 'equis' ) {
						tab.close();
						if ( reportsTab )
							reportsTab.show();
						return;
					}

					objectURL = URL.createObjectURL(request.response);

					// "Content-Disposition:inline;filename=\"filename\""
					const contentDisposition = request.getResponseHeader("Content-Disposition");
					if (contentDisposition) {
						let parts = contentDisposition.split('=');
						if (parts.length > 1 && parts[1])
							anchor.download = decodeURIComponent(parts[1].substring(1, parts[1].length - 1).replace(/\+/g, '%20'));

						if (!anchor.download)
							anchor.download = filename;
					}

					anchor.href = objectURL;
					span.innerText = anchor.download;

					const contentType = request.getResponseHeader("Content-Type");
					console.log( contentType );
					if (
						contentType == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
						|| contentType == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
						|| contentType == 'text/csv;charset=UTF-8'
					) {
						anchor.click();
						if ( reportsTab )
							reportsTab.show();
						tab.close();
						return;
					}

					tab.show();
					reportObject = document.createElement('object');
					const margin = contentType == 'text/plain;charset=UTF-8' ? '3em' : '0';
					reportObject.setAttribute('style', 'margin:' + margin + ';padding:0;width:100%;height:100%;border:none;');
					reportObject.setAttribute('type', contentType);
					reportObject.setAttribute('data', objectURL);
					tab.container.appendChild(reportObject);
				};
				request.onerror = function() {
					tab.show();
					reportObject = document.createElement('div');
					reportObject.setAttribute('style', 'margin:6em;width:auto;height:auto;text-align:center;');
					reportObject.innerText = request.statusText;
					tab.container.appendChild(reportObject);
				};
				request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
				data.session_id = ajax_object.session_id;
				data.action = 'generate_report';
				request.send( JSON.stringify( data ) );
				//if ( !data.emailTo && data.reportType != 'dnr-disk' && data.reportType != 'equis' )
					//tab.show();
			},
			onTabClose() {
				reset();
			},
		} );
	}
});

})();